import { Component, effect, inject, OnInit, signal } from '@angular/core';

import { RouterModule } from '@angular/router';

import { ExpertHeaderComponent } from '../../components';
import { AuthStore, BouncingLoaderComponent } from '@sandbox-platform/shared-ui';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    ExpertHeaderComponent,
    BouncingLoaderComponent,
  ],
  selector: 'lib-expert-layout',
  template: `
    @if (isLoading()) {
    <div class="flex justify-center items-center h-screen bg-white">
      <lib-bouncing-loader [message]="'SNDBX Experts'" />
    </div>
    } @else {
    <div class="h-screen bg-gray-50 grid grid-rows-[auto_1fr] overflow-hidden">
      <lib-expert-header class="sticky top-0 z-50" />

      <div class="min-h-0 px-4 sm:px-6 lg:px-8 py-4 bg-gray-50 overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
    }
  `,
})
export class ExpertLayoutComponent implements OnInit {
  readonly authStore = inject(AuthStore);
  public isLoading = signal(true);
  private readonly authResolutionMonitor = effect(() => {
    const user = this.authStore.user();
    const hasResolvedPermissions =
      !!user && user.svc_perms !== undefined;

    this.isLoading.set(!hasResolvedPermissions);
  });

  ngOnInit(): void {
    this.authStore.loadFromStorage();
  }
}
